<template>
  <h1 class="main-title">
    <slot />
  </h1>
</template>

<style scoped>
.main-title {
  font-size: var(--font-size-24px);
  /* boldのみ */
  font-weight: var(--font-weight-bold);
}
.main-title.label {
  /* 確定時の時間など、重要な情報のラベルに使用  後で追加した*/
  font-weight: var(--font-weight-medium);
}
</style>
